import React, {Component} from 'react'
import {Button, Form, Row, Col, Input, Table, Modal, Select} from 'antd'
import {toJS} from 'mobx'
import {DeleteOutlined, QuestionCircleFilled, EditOutlined, SearchOutlined, PlusOutlined, ImportOutlined, DownloadOutlined} from '@ant-design/icons'
import forumlaInfoAPI from '../../apis/forumlaInfo'
import {getPaginationConfig} from '../../components/pagination'
import AddFormModal from './AddFormModal'
import EditFormModal from './EditFormModal'
import FormImport from './FormImport'
import UPM from '../../constants/urlPermissionMappings'
import {withTranslation} from 'react-i18next'

const {confirm} = Modal

class forumlaType extends Component {
  state = {
    page: 1, // 当前页
    size: 10, // 每页显示条数
    total: null, // 总条数
    addModalVisible: false,
    editModalVisible: false,
    importModalVisible: false,
    id: null,
    tableData: [],
    formulaTypeIdOption: []
  }
  formRef = React.createRef()

  componentDidMount() {
    forumlaInfoAPI.getFormulaTypeAction().then(res => {
      this.setState({
        formulaTypeIdOption: res.data.data
      })
    })
    this.handleSearch(1, 10)
  }

  handleSearch = (page, size) => {
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        name: fieldsValue.name,
        formulaTypeId: fieldsValue.formulaTypeId,
        page: page ? page : this.state.page,
        size: size ? size : this.state.size,
      }
      forumlaInfoAPI.searchAction(params).then(res => {
        this.setState({
          tableData: res.data.data?.records,
          page: res.data.data.current, // 当前页
          size: res.data.data.size, // 每页显示条数
          total: res.data.data.total // 总条数
        })
      })
    }).catch(err => {
    })
  }

  handleCreate = () => {
    this.setState({
      addModalVisible: true
    })
  }

  handleCancel = (target) => {
    this.setState({
      [target]: false
    })
  }

  handlePageChange = (page, pageSize) => {
    // page 目标页
    // pageSize 显示条数
    this.handleSearch(page, pageSize)
  }

  handleEdit = (id) => {
    this.setState({
      editModalVisible: true,
      id
    })
  }

  handleImport = () => {
    this.setState({
      importModalVisible: true
    })
  }

  handleExport = () => {
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        name: fieldsValue.name,
        formulaTypeId: fieldsValue.formulaTypeId,
        page: this.state.page,
        size: this.state.size
      }
      forumlaInfoAPI.exportAction(params).then(res => {
        var blob = new Blob([res.data.data], {type: 'text/plain;charset=utf-8'}) //解决中文乱码问题
        blob = new Blob([String.fromCharCode(0xFEFF), blob], {type: blob.type})
        //设置链接
        var link = window.URL.createObjectURL(blob)
        var a = document.createElement('a') //创建a标签
        a.download = 'FormulaInfoConfig.txt' //设置被下载的超链接目标（文件名）
        a.href = link //设置a标签的链接
        document.body.appendChild(a) //a标签添加到页面
        a.click() //设置a标签触发单击事件
        document.body.removeChild(a) //移除a标签
      })
    }).catch(err => {

    })
  }

  handleDel = (record) => {
    const {t} = this.props
    let _this = this
    confirm({
      title: t(`general.deleteData`),
      icon: <QuestionCircleFilled/>,
      content: t(`general.sureToDelete`),
      okText: t(`general.delete`),
      cancelText: t(`general.cancel`),
      onOk() {
        forumlaInfoAPI.delAction(record.id).then(res => {
          _this.handleSearch()
        })
      },
      onCancel() {
        console.log('Cancel')
      },
    })
    return false
  }

  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }
  render() {
    const {location, t} = this.props
    const pagination = getPaginationConfig(this.state.page, this.state.size, this.state.total, this.handlePageChange)

    return (
      <div className="container">
        <Form ref={this.formRef} size="middle" className="searchForm" layout="vertical">
          <div className="searchFormTitle">
            <SearchOutlined/> {t(`menu.${UPM.find(item => item.url === location?.pathname)?.pKey}`)}
          </div>
          <Row gutter={[10, 0]}>
            <Col span={4}>
              <Form.Item name="name" label={t(`formulaInfo.formulaName`)}>
                <Input placeholder={t(`general.pleaseEnter`)} allowClear/>
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item name="formulaTypeId" label={t(`formulaInfo.formulaType`)}>
                <Select placeholder={t(`general.pleaseSelect`)} onChange={this.onChange} allowClear>
                  {
                    this.state.formulaTypeIdOption.map((e, i) => {
                      return (
                        <Select.Option key={e.id} value={e.id}>{e.name}</Select.Option>
                      )
                    })
                  }
                </Select>
              </Form.Item>
            </Col>
            <Col span={12} offset={4} style={{textAlign: 'right', marginTop: 30}}>
              <Button onClick={() => { this.handleSearch(1, 10) }} type='danger'>{t(`general.search`)}</Button>
              <Button onClick={this.handleCreate} type="primary" icon={<PlusOutlined/>}>{t(`general.add`)}</Button>
              <Button onClick={this.handleImport} type="primary" icon={<ImportOutlined/>}>{t(`general.import`)}</Button>
              <Button onClick={this.handleExport} type="primary" icon={<DownloadOutlined/>}>{t(`general.export`)}</Button>
            </Col>
          </Row>
        </Form>

        <Table className="searchResult" dataSource={toJS(this.state.tableData)} rowKey="id" pagination={pagination} rowClassName={this.getRowClassName}>
          <Table.Column title={t(`formulaInfo.formulaName`)} dataIndex="name" key="name" ellipsis={true}/>
          <Table.Column title={t(`formulaInfo.formulaType`)} dataIndex="formulaTypeName" key="formulaTypeName" ellipsis={true}/>
          <Table.Column title={t(`formulaInfo.description`)} dataIndex="description" key="description" ellipsis={true}/>
          <Table.Column title={t(`formulaInfo.examples`)} dataIndex="examples" key="examples" ellipsis={true}/>
          <Table.Column align="center" title={t(`general.action`)} key="Action" render={(text, record) => (
            <>
              <Button type="link" onClick={() => this.handleEdit(record.id)} icon={<EditOutlined/>} title={t(`general.edit`)}/>
              <Button type="link" onClick={() => this.handleDel(record)} icon={<DeleteOutlined/>} title={t(`general.delete`)}/>
            </>
          )}/>
        </Table>
        {this.state.addModalVisible ?
          <AddFormModal handleCancel={this.handleCancel} handleSearch={this.handleSearch} addModalVisible={this.state.addModalVisible}/> : null}
        {this.state.editModalVisible ? <EditFormModal handleCancel={this.handleCancel} id={this.state.id} handleSearch={this.handleSearch}
                                                      editModalVisible={this.state.editModalVisible}/> : null}
        {this.state.importModalVisible ?
          <FormImport handleCancel={this.handleCancel} handleSearch={this.handleSearch} importModalVisible={this.state.importModalVisible}/> : null}
      </div>
    )
  }
}

export default withTranslation()(forumlaType)
